export class ViewStateLayouts {
    public static CARD: string = 'list';
    public static CONDENSE: string = 'condense';
    public static CAST_CARD: string = 'castlist';
    public static TILE: string = 'timeline';
    public static MAP: string = 'map';
    public static TRENDS: string = 'trends';
    public static WIRE: string = 'wire';
}
